import React from "react";
import {SearchForm} from "./searchForm"
import ApplyList from "./applyList"
const Apply = (): JSX.Element => {
    return (
        <>
            <SearchForm/>
            <ApplyList/>
        </>
    )
}
export default Apply